// -----------------------------------------------------------------------------
// Exports
//  `rachel`, `richard`
// -----------------------------------------------------------------------------

const TESTIMONIAL = [
  {
    uuid: `zahid`,
    avatarImage: { url: `/images/patient-zahid.svg` },
    name: `Zahid`,
    location: `West Midlands`,
    age: 24,
    color: `25904e`,
    quote: `I’ve really enjoyed my time doing Sleepstation. The techniques that have been suggested to me **have made big differences** to my sleep already. I’ve learnt so many things about sleep and my own sleep is improving because of this.`,
  },
  {
    uuid: `jackie`,
    avatarImage: { url: `/images/jackie.svg` },
    name: `Jackie`,
    location: `Leicester`,
    profession: `Dinner lady`,
    age: 54,
    context: `Insomnia for six months`,
    color: `25904e`,
    quote: `Being accepted onto **the Sleepstation programme has completely turned my life around**. Before the course I was paralysed by anxiety, had been signed off work and dreaded going to bed due to the sleep problems I had been experiencing for months. **Within a few weeks of being on the course, the quality of my sleep had improved and the anxiety levels started dropping**. I feel so lucky to have found the course as **it has given me my life back**.`,
  },
  {
    uuid: `fay`,
    avatarImage: { url: `/images/patient-fay.svg` },
    name: `Fay`,
    location: `Derbyshire`,
    age: 44,
    color: `25904E`,
    quote: `I have enjoyed a good night’s sleep every night, medication-free! I never thought this would be possible for me and I really can’t thank you enough. **You really have changed my life** and I haven’t felt better in years. Thank you; you’re all wonderful.`,
  },
  {
    uuid: `rachel`,
    avatarImage: { url: `/images/patient-rachel.svg` },
    name: `Rachel`,
    location: `Eckington`,
    age: 24,
    color: `25904E`,
    quote: `**This course was the best thing that’s happened for me in a very long time**. I finally feel like I have the knowledge and skills to improve my sleep and manage any relapses. **I felt well looked after by the Sleepstation team** and found the sleep diaries very helpful. 10/10. **I would recommend this service to anyone** suffering from insomnia.`,
  },
  {
    uuid: `richard`,
    avatarImage: { url: `/images/patient-richard.svg` },
    name: `Richard`,
    location: `Maidstone`,
    profession: `Manager`,
    age: 45,
    context: `Insomnia for more than three years`,
    color: `25904e`,
    quote: `This course has been fantastic. **The results have been life changing**. I look forward to going to bed and usually have the confidence to know I will fall asleep within 15 minutes. This course has given me the confidence and tactics to further improve my sleep in the future **without sleeping pills**! Thank you.`,
  },
]

export default TESTIMONIAL
